import React, {useRef, useState, useEffect} from 'react'
import {Icon, IconName} from "./Icon"
import './DeleteButton.less'

interface DeleteButtonProps {
    onDelete: () => void
    tooltipText?: string
    className?: string
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
                                                                onDelete,
                                                                tooltipText = 'Delete',
                                                                className = ''
                                                            }) => {
    const [isConfirming, setIsConfirming] = useState(false)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const handleClick = () => {
        if (isConfirming) {
            onDelete()
            setIsConfirming(false)
        } else {
            setIsConfirming(true)
        }
    }

    const handleCancel = () => {
        setIsConfirming(false)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
                setIsConfirming(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    return (
        <div className={['delete-button-container', className].join(' ')}>
            <button
                ref={buttonRef}
                className="delete-button"
                onClick={handleClick}
                aria-label="Delete"
                title={isConfirming ? 'Are you sure you want to delete?' : tooltipText}
            >
                <Icon
                    name={IconName.Delete}
                    className={['delete-icon', isConfirming ? 'confirming' : ''].join(' ')}
                    width="20"
                    height="20"
                />
            </button>
        </div>
    )
}
